import axios from 'axios'
import { i18n } from '../../../plugins/i18n'

import { castAttributesForCamelCase } from '../../../modules/string_converter'

export const companiesCustomSurveyAnswerFiles = {
  namespaced: true,
  state: {
    data: null,
    meta: null,
    loading: false,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    readFilesSuccess(state, payload) {
      state.data = payload.data.map(data => {
        const castData = castAttributesForCamelCase(data)
        castData['importErrors'] = castData['importErrors'].map(data => castAttributesForCamelCase(data))
        return castData
      })
      state.meta = castAttributesForCamelCase(payload.meta)
      state.loading = false
    },
    deleteSuccess(state, id){
      state.data = state.data.filter((value) => value.id !== id)
      state.loading = false
    },
    apiSuccess(state) {
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    },
  },
  actions: {
    readFiles({ commit, rootState }, { customSurveyId, query }) {
      commit('prepareConnect')
      axios
        .get(`/api/companies/${rootState.route.params.company_uuid}/custom_surveys/${customSurveyId}/answer_files.json`, {params: query})
        .then(res => {
          commit('readFilesSuccess', res.data)
        })
        .catch(err => {
          console.log(err)
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    uploadFile({ commit, rootState }, { customSurveyId, data }) {
      commit('prepareConnect')
      return axios
        .post(`/api/companies/${rootState.route.params.company_uuid}/custom_surveys/${customSurveyId}/answer_files.json`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
        .then(res => {
          commit('apiSuccess', res.data)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.upload', { value: i18n.t('labels.csv') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
    deleteFile({ commit, rootState }, { customSurveyId, id }) {
      commit('prepareConnect')
      axios
        .delete(`/api/companies/${rootState.route.params.company_uuid}/custom_surveys/${customSurveyId}/answer_files/${id}`)
        .then(() => {
          commit('deleteSuccess', id)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.deleted', { value: i18n.t('labels.csv') }) }, { root: true })
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    downloadTemplate({ commit, rootState }, customSurveyId) {
      return axios
        .get(`/api/companies/${rootState.route.params.company_uuid}/custom_surveys/${customSurveyId}/answer_file_templates`, {
          responseType: 'arraybuffer',
        })
        .then(res => {
          const link = document.createElement('a')
          link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/zip' }))
          link.download = 'template.zip'
          link.click()
        })
        .catch(err => {
          console.log(err)
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    downloadFile({ commit, rootState }, {customSurveyId, id, filename}) {
      return axios
        .get(`/api/companies/${rootState.route.params.company_uuid}/custom_surveys/${customSurveyId}/answer_files/${id}`, {
          responseType: 'arraybuffer',
        })
        .then(res => {
          const link = document.createElement('a')
          link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/csv' }))
          link.download = filename
          link.click()
          commit('apiSuccess')
        })
        .catch(err => {
          console.log(err)
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    }
  }
}
